import React, { useState } from 'react';
import './App.css';

function Login() {
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [mensaje, setMensaje] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const respuesta = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ correo, password })
      });
      
      if (respuesta.ok) {
        const datos = await respuesta.json();
        // Guardamos la sesión en el navegador
        localStorage.setItem('aspe_usuario', JSON.stringify(datos.usuario));
        // Redirigimos al panel principal
        window.location.href = '/dashboard';
      } else {
        setMensaje('Error: Correo o contraseña incorrectos.');
      }
    } catch (error) {
      setMensaje('Error de conexión con el servidor.');
    }
  };

  return (
    <div className="login-pantalla">
      <div className="login-caja">
        <img src="/logo.png" alt="ASPE Logo" className="login-logo" />
        <h2>Portal Administrativo</h2>
        <p>Ingrese sus credenciales corporativas</p>
        
        <form onSubmit={handleLogin} className="login-form">
          <input 
            type="email" 
            placeholder="Correo corporativo" 
            value={correo} 
            onChange={(e) => setCorreo(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            placeholder="Contraseña" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          <button type="submit" className="login-boton">Ingresar al Sistema</button>
        </form>
        {mensaje && <p className="login-mensaje">{mensaje}</p>}
      </div>
    </div>
  );
}

export default Login;